import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'nl_NL',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'f64ce472-8085-412a-9b57-3b6ecd494531',
  ''
);
